<section class="d-flex flex-column flex-grow-1" (mouseenter)="showText.set(true)" (mouseleave)="showText.set(false)">

  <!-- Card Header - Title and Subtitle -->
  <div class="product-card__head" [ngClass]="{'card-img active-filter-blur': isOutOfStock()}">
    <a [routerLink]="productRouterLink()">
      <h3 class="product-card__title" [ngbTooltip]="productNameTooltip()">{{productName()}}</h3>
    </a>
    <h5 class="product-card__subtitle">{{producerName()}}</h5>
  </div>

  <div class="product-card__img-wrap" [ngClass]="{'card-img active-filter-blur': isOutOfStock()}">
    <!-- Sale Badge -->
    @if(selectedAttributeCardConfig().hasDiscount && selectedAttributeCardConfig().isOnSale) {
    <span class="sale-badge">{{isMobile() ? 'Sale' : 'On Sale'}}</span>
    }

    <!-- Fav Icon -->
    @if(hasSession()) {
    <label [for]="'isFavorite'+card().product.id" class="custom-checkbox">
      <input type="checkbox" [id]="'isFavorite'+card().product.id" [disabled]="isDisabledActionButtons()"
        (change)="handleFavoriteChange()" [checked]="isFavorite()" />
      <i class="fa-heart fa-regular text-danger"></i>
      <i class="fa-heart fa-solid text-danger"></i>
    </label>
    }
    <a [routerLink]="productRouterLink()">
      @defer (on viewport; prefetch on immediate) {
      <img [src]="productImg()" (error)="handleImageError($event)" class="product-card__img">
      } @placeholder {
      <div class="product-card__img"></div>
      }
    </a>

    <!-- Hovered Button over main image -->
    @if (card().product.bundle?.items?.length) {
    <div class="info-badge">
      <button class="rolling-info" (click)="outOpenModalWhatsInside.emit($event)" [class.active]="showText()">
        <i class="rolling-info-icon fas fa-info-circle"></i>
        <span class="rolling-info__text" [class.active]="showText()">
          What's inside
        </span>
      </button>
    </div>
    }

    @if (!marketStatus().isOpen && !card().product.preOrder &&
    !selectedAttributeCardConfig().isSubscription) {
    <div class="d-grid position-absolute bottom-0 pb-3 w-100">
      <div class="mb-0 w-100 alert py-2 px-3 alert-warning d-flex align-items-center animated fadeIn" role="alert">
        @if (isMobile()) {
        <div class="h8-regular text-center">
          Available <b>on {{marketStatus().openingDay | titlecase}}</b>
        </div>
        } @else {
        <div class="h7-regular">
          You'll be <b>able to add</b> items to your cart on <b>{{marketStatus().openingDay |
            titlecase}}</b> Morning
          <!-- <b>{{marketStatus().openingHour}}</b>-->
        </div>
        }
      </div>
    </div>
    }
  </div>

  @if (isOutOfStock() || isOutOfStockPerQuantity()) {
  <app-out-of-stock [class.oosperQuantity]="isOutOfStockPerQuantity()"
    [isOutOfStockPerQuantity]="isOutOfStockPerQuantity()" [isOutOfStock]="isOutOfStock()" [hasNotify]="hasNotify()"
    [isFromSummary]="false" (outFlipCardType)="outFlipCardType.emit({type: $event})"
    (outModalCheckAddress)="outModalCheckAddress.emit()"></app-out-of-stock>
  }
  <section [class.d-none]="isOutOfStock()">
    <div class="product-card__meta">
      <div class="product-card__meta--item is-col-2">
        <div class="d-grid">
          <div class="d-flex gap-1 d-flex gap-1 flex-row align-items-center">
            @if(!selectedAttributeCardConfig().isABundle &&
            !selectedAttributeCardConfig().bundle?.items?.length &&
            selectedAttributeCardConfig().bundle?.priceRange) {
            <h5 class="product-card__price">{{ selectedAttributeCardConfig().bundle?.priceRange }}
            </h5>
            } @else {
            <h5 class="product-card__price">{{ selectedAttributeCardConfig().price | currency }}
            </h5>
            }
            @if(selectedAttributeCardConfig().hasDiscount) {
            <small class="product-card__price--line-through text-body-tertiary fw-bold text-decoration-line-through">
              {{selectedAttributeCardConfig().originalPrice | currency}}
            </small>
            }
          </div>
          @if (selectedAttributeCardConfig().display) {
          <p class="product-card__info">
            {{selectedAttributeCardConfig().display || ''}}
          </p>
          }
        </div>

        <!-- Quantity buttons -->
        <div class="col quantity">
          @if (wasValueHigher10()) {
          <small class="how-many-label d-none d-sm-block">How many?</small>
          }
          <mat-form-field class="rounded-selector d-flex" subscriptSizing="dynamic">
            @if( wasValueHigher10() || newQuantity() >= 10 || (newQuantity() >= 10 &&
            wasValueHigher10()) ){
            <input type="text" matInput appNumberRestriction [minNumber]="1" [maxNumber]="totalStockAvailable()"
              (change)="outOnInputQuantityChange.emit($event)" (keyup)="outOnKeyUp.emit($event)"
              [value]="newQuantity()">
            }
            @else{
            <mat-select [value]="newQuantity()" (selectionChange)="outOnQuantityChange.emit($event)">
              @for(q of availableQuantities(); track $index){
              <mat-option [value]="q.val">{{ q.name }}</mat-option>
              }
            </mat-select>
            }
          </mat-form-field>
        </div>

      </div>

      <div class="row">
        <!-- Product Customizations  -->
        <div class="col-12 d-flex gap-1">
          @if (card().settings.showAttributes) {
          @if (productAttributes().length) {
          @for (attr of productAttributes(); track $index) {
          <mat-form-field class="rounded-selector" subscriptSizing="dynamic">
            <mat-label class="text-capitalize">{{attr.name.toLowerCase()}}</mat-label>
            @if (card().product.variantId || attr.values.length === 1) {
            <input matInput type="text" readonly="true" [value]="selectedAttribute()?.value.name">
            } @else {
            <mat-select [value]="selectedAttribute()?.value?.id || ''"
              (selectionChange)="outOnAttributeChange.emit({id: attr.id, event: $event})">
              @for (item of attr.values; track $index) {
              <mat-option [value]="item.id">{{item.name}}</mat-option>
              }
            </mat-select>
            }
          </mat-form-field>
          }
          }
          @if (card().product.packages?.length) {
          <mat-form-field class="rounded-selector" subscriptSizing="dynamic">
            <mat-label class="text-capitalize">Package</mat-label>
            @if (card().product.packages?.length === 1) {
            <input matInput type="text" readonly="true" [value]="selectedPackage()?.name">
            } @else {
            <mat-select [value]="selectedPackage()?.id || ''"
              (selectionChange)="outOnPackageChanged.emit($event.value)">
              @for (item of card().product.packages; track $index) {
              <mat-option [value]="item.id">{{item.name}}</mat-option>
              }
            </mat-select>
            }
          </mat-form-field>
          }
          }
        </div>
      </div>
    </div>

    <!-- Action button -->
    <div class="product-card__action">
      <div class="d-grid gap-2">
        @if (hasSession()) {
        @if (isFromWelcome()) {
        <button type="button" [disabled]="isDisabledSubscribeButton()"
          (click)="outFlipCardType.emit({type: cardTypes.subscribe})"
          class="btn btn-secondary d-flex gap-2 align-items-center">
          {{getButtonTextSubscription()}}
        </button>
        } @else {
        @if (selectedAttributeCardConfig().isSubscription) {
        @if (card().product.bundle?.items?.length) {
        <div [class.action-col-2]="marketStatus().isOpen && selectedAttributeCardConfig().isALaCarte">
          @if(stockSignal().size) {
          @if (marketStatus().isOpen && selectedAttributeCardConfig().isALaCarte) {
          <button (click)="outAddProductToCart.emit({isSubscription: false, event: $event})"
            [disabled]="isDisabledActionButtons()" class="btn btn-outline-secondary d-flex gap-2 align-items-center">
            @if (isMobile()) {
            <i class="fas fa-plus"></i>
            } @else {
            {{getButtonTextBundle()}}
            }
          </button>
          }
          <button [disabled]="isDisabledSubscribeButton()" (click)="outFlipCardType.emit({type: cardTypes.subscribe})"
            class="btn btn-secondary d-flex gap-2 align-items-center">
            {{getButtonTextBundleSubscription()}}
          </button>
          } @else {
          <p class="placeholder-glow mb-0 w-100">
            <span
              class="placeholder w-100 col-12 bg-secondary rounded btn btn-secondary d-flex gap-2 align-items-center"
              style="height: 36px;"></span>
          </p>
          }
        </div>
        }
        @else {
        <div [class.action-col-2]="marketStatus().isOpen && selectedAttributeCardConfig().isALaCarte">
          @if(stockSignal().size) {
          @if (marketStatus().isOpen && selectedAttributeCardConfig().isALaCarte) {
          <button (click)="outAddProductToCart.emit({isSubscription: false, event: $event})"
            [disabled]="isDisabledActionButtons()" class="btn btn-outline-secondary d-flex gap-2 align-items-center">
            @if (isMobile()) {
            <i class="fas fa-plus"></i>
            } @else {
            {{getButtonTextSingle()}}
            }
          </button>
          }
          <button [disabled]="isDisabledSubscribeButton()" (click)="outFlipCardType.emit({type: cardTypes.subscribe})"
            class="btn btn-secondary d-flex gap-2 align-items-center">
            {{getButtonTextSubscription()}}
          </button>
          } @else {
          <p class="placeholder-glow mb-0 w-100">
            <span
              class="placeholder w-100 col-12 bg-secondary rounded btn btn-secondary d-flex gap-2 align-items-center"
              style="height: 36px;"></span>
          </p>
          }
        </div>
        }
        }
        @else {
        @if(stockSignal().size && selectedAttributeCardConfig().isALaCarte) {
        <button type="button" (click)="outAddProductToCart.emit({isSubscription: false, event: $event})"
          [disabled]="isDisabledActionButtons() || (!card().product.preOrder && !marketStatus().isOpen)"
          class="btn btn-secondary d-flex gap-2 align-items-center"
          [class.btn-outline-secondary]="existsInOrder().common || isPreOrderedVariant()">
          {{getButtonTextSingle()}}
        </button>
        } @else {
        <p class="placeholder-glow mb-0 w-100">
          <span class="placeholder w-100 col-12 bg-secondary rounded btn btn-secondary d-flex gap-2 align-items-center"
            style="height: 36px;"></span>
        </p>
        }
        }
        }
        }
        @else {
        <button (click)="outOpenModalCheckAddress.emit()" class="btn btn-secondary d-flex gap-2 align-items-center">
          Sign Up
        </button>
        }
      </div>
    </div>

    <div class="product-card__foot" #tagsContainer>
      <!-- Tags Icons -->
      <ul class="product-card__tags">
        @for (tag of card().product.tags || []; track $index) {
        <li #tagsItemList>
          @if (tag.icon) {
          <img src="{{tag.icon}}" [alt]="tag.name" [ngbTooltip]="tag.name" />
          } @else {
          <span class="material-symbols-outlined" [ngbTooltip]="tag.name">
            info
          </span>
          }
        </li>
        }
      </ul>
    </div>

  </section>

</section>